/**
 * Labstep
 *
 * @module components/Filter/AssignedTo
 * @desc Filter Assigned To
 */

import { FilterUser } from 'labstep-web/components/Filter/User';
import type React from 'react';
import type { FilterAssignedToProps } from './types';

export const FilterAssignedTo: React.FC<FilterAssignedToProps> = (
  props,
) => (
  <FilterUser
    {...props}
    type="assignee"
    header={'Assigned to'}
    icon="user plus"
  />
);
